module.exports = __webpack_public_path__ + "media/images/game/resources/satisfaction_tiny-943b495be8ef6b8c3cd13f2cef2f513b.png";